import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsDisplay } from 'react-icons/bs';
import { Course } from '../../../../../../types/course.type';

/** Screen icon → Zoom for online lessons that are today or later. */
export const OnlineJoinEventIcon = ({
  course,
  lessonDate,
  lessonId
}: {
  course?: Course | null;
  lessonDate?: string | null;
  lessonId: number | string;
}) => {
  const videoUrl = course?.video_url?.trim();
  const lessonDay = String(lessonDate ?? '').slice(0, 10);
  const today = new Date();
  const todayDay = [
    today.getFullYear(),
    String(today.getMonth() + 1).padStart(2, '0'),
    String(today.getDate()).padStart(2, '0')
  ].join('-');
  const isUpcomingOrInProgress = Boolean(lessonDay) && lessonDay >= todayDay;
  const showJoinLink =
    Boolean(course?.is_online) && Boolean(videoUrl) && isUpcomingOrInProgress;

  if (!showJoinLink || !videoUrl) return null;

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={`join-event-${lessonId}`}>Join The Event</Tooltip>}
    >
      <a
        href={videoUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="text-info d-inline-flex"
        aria-label="Join The Event"
      >
        <BsDisplay size={16} />
      </a>
    </OverlayTrigger>
  );
};
